import http from "../http-common";
import authHeader from "./authHeader";
import { FEED_API } from "../api";

const getAllFeeds = (offset, limit) => {
  return http.get(`${FEED_API}?limit=${limit}&offset=${offset}`);
};
const getFeedCount = () => {
  return http.get(`${FEED_API}/count`);
};
//TODO: in BE
// const getAllFeedsOfCustomer = (id) => {
//   return http.get(`${FEED_API}/customer/${id}`, { headers: authHeader() });
// };

//TODO: in BE
// const getAllFeedsOfTypesOfCustomer = (id) => {
//   return http.get(`${FEED_API}/types/${id}`, { headers: authHeader() });
// };

const createFeeds = (data) => {
  return http.post(`${FEED_API}`, data, { headers: authHeader() });
};

const updateFeeds = (data) => {
  return http.post(`${FEED_API}/update`, data, { headers: authHeader() });
};

const FeedsService = {
  getAllFeeds,
  // getAllFeedsOfCustomer,
  createFeeds,
  updateFeeds,
  // getAllFeedsOfTypesOfCustomer,
  getFeedCount,
};

export default FeedsService;
